"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FriendsWaveImage = exports.Heading = exports.TextWrapper = exports.WelcomeStepWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const streamline_icon_friends_wave_svg_1 = __importDefault(require("@public/media/illustrations/streamline-icon-friends-wave.svg"));
const styled_breakpoints_1 = require("styled-breakpoints");
exports.WelcomeStepWrapper = styled_components_1.default.div `
	margin-top: 1rem;
	text-align: center;

	${(0, styled_breakpoints_1.down)('sm')} {
		margin-top: 0.5rem;
	}
`;
exports.TextWrapper = styled_components_1.default.div `
	font-size: 1.2rem;
	text-align: center;
	margin: 2rem 0;
	color: ${props => props.theme.color.gray6};
	max-width: 700px;

	${(0, styled_breakpoints_1.down)('sm')} {
		margin: 1rem 0;
	}
`;
exports.Heading = styled_components_1.default.h2 `
	margin-bottom: 2rem;

	${(0, styled_breakpoints_1.down)('sm')} {
		margin-bottom: 0;
	}
`;
exports.FriendsWaveImage = (0, styled_components_1.default)(streamline_icon_friends_wave_svg_1.default) `
	height: 200px;
	width: 200px;

	${(0, styled_breakpoints_1.down)('sm')} {
		width: 100px;
		height: 100px;
	}
`;
